import { render, staticRenderFns } from "./InsightEditList.vue?vue&type=template&id=9d64d788&scoped=true"
import script from "./InsightEditList.vue?vue&type=script&lang=js"
export * from "./InsightEditList.vue?vue&type=script&lang=js"
import style0 from "./InsightEditList.vue?vue&type=style&index=0&id=9d64d788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d64d788",
  null
  
)

export default component.exports